/**
 * @file dispatchCalcScores.ts
 * Exports a method that calculates the scores property of AppState.
 */
import { prop } from 'ramda';
import { getSelectedAnswer, getSubmittedTrueValues } from '.';
import type { AppState } from '../types';

/**
 * Helper method that returns App point based on submitted answers.
 *
 * @todo: This method has many responsibilities. Consider refactoring to create
 *   a series of single purpose utility functions.
 *
 * @param {AppState} appState
 *   The state object shared across the application.
 *
 * @returns {Number}
 *   A app point number will return based on calculation
 */
export default (appState: AppState): number => {
  const {
    appData: { appPoints },
  } = appState;
  const submittedValue = getSubmittedTrueValues(appState);
  const q1 = submittedValue[0];
  const q2 = submittedValue[1];
  const queArray = [q1, q2];
  const multipleQueExist =
    queArray.length &&
    queArray.every((value) => {
      return submittedValue.includes(value);
    });
  const calculateAccountAppValue = () => {
    const value = getSelectedAnswer(appState);
    if (multipleQueExist) {
      const q1Val = Number(value[0].answer.split(' ')[0].split('-')[1]);
      const q2Val = Number(value[1].answer.split(' ')[0]);
      const totalValue = q1Val * q2Val;
      let totalAccountNum;
      if (totalValue > appPoints.metric) {
        totalAccountNum = Math.ceil(
          (totalValue - appPoints.metric) / appPoints.per,
        );
        const appAccountPoint =
          totalAccountNum * appPoints.additional + appPoints.basePoint;
        return appAccountPoint;
      } else {
        return appPoints.basePoint;
      }
    } else {
      return 0;
    }
  };

  const subQueAppPoint: any = appPoints.subQueAppPoint;

  let totalOtherAppPoints = 0;

  const submitted = prop('submitted')(appState);

  // First loop your questions
  for (const question in submitted) {
    // Then loop all answers in that question
    for (const [answer, value] of Object.entries(submitted[question])) {
      // Check if answer is 'Yes' and if that question even exists in possible question pool
      if (
        (value as string).split('Cookie-')[1] === 'Yes' &&
        typeof subQueAppPoint[answer] === 'object'
      ) {
        totalOtherAppPoints = Object.values(subQueAppPoint[answer]).reduce(
          (a: number, b: any) => a + b,
          0,
        );
      } else if (
        (value as string).split('Cookie-')[1] === 'Yes' &&
        subQueAppPoint[answer] != null
      ) {
        // Sum up total points
        totalOtherAppPoints += subQueAppPoint[answer];
      }
    }
  }

  const totalAccountAppPoint = calculateAccountAppValue();

  return totalAccountAppPoint + totalOtherAppPoints;
};
